import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { WorkflowTemplateDetails } from "@idw-types/data/workflow-template-details";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type CreateWorkflowTemplateRequestResponse = {
    response: WorkflowTemplateDetails;
};

export const createWorkflowTemplateRequest = async (
    workflowTemplate: Partial<WorkflowTemplateDetails>
): Promise<GenericNetworkResponse<CreateWorkflowTemplateRequestResponse>> => {
    const route = apiRoutes.serviceConfiguration.data.workflowTemplate;

    const body: Partial<WorkflowTemplateDetails> = {
        id: null,
        description: workflowTemplate.description,
        descriptionURL: workflowTemplate.descriptionURL,
        name: workflowTemplate.name,
        organizationID: workflowTemplate.organizationID,
        template: workflowTemplate.template,
        status: "active"
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};